import { render } from "./AssignmentDetailsModal.vue?vue&type=template&id=57e6325a&scoped=true"
import script from "./AssignmentDetailsModal.vue?vue&type=script&lang=js"
export * from "./AssignmentDetailsModal.vue?vue&type=script&lang=js"

import "./AssignmentDetailsModal.vue?vue&type=style&index=0&id=57e6325a&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./AssignmentDetailsModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e6325a"]])

export default __exports__